import PropTypes from 'prop-types';
import React from 'react';
import CollegeApplicationStatusQuestionMenu from 'shared/college-application-status/components/college-application-status-question-menu';

class CollegeApplicationStatusCard extends React.Component {
  static propTypes = {
    college: PropTypes.object.isRequired,
    collegeApplicationStatus: PropTypes.object.isRequired,
    setCollegeAppStatus: PropTypes.func.isRequired,
    questionButtonOnClick: PropTypes.func,
  };

  render() {
    const {college, collegeApplicationStatus, setCollegeAppStatus, questionButtonOnClick} =
      this.props;

    return (
      <div className="college-application-status-card">
        <img src={college.logo} className="college-logo" alt="college logo" aria-hidden="true" />
        <div className="college-name">{college.name}</div>
        <CollegeApplicationStatusQuestionMenu
          college={college}
          collegeApplicationStatus={collegeApplicationStatus}
          setCollegeAppStatus={setCollegeAppStatus}
          questionButtonOnClick={questionButtonOnClick}
          segmentEventLocation="portfolio modal"
        />
      </div>
    );
  }
}

export default CollegeApplicationStatusCard;
